import { IconButton, Tooltip } from "@mui/material";
import theme from "../../theme";

export const OpenFormButton = ({
  onClick,
  tooltip = "",
  icon: IconComponent = null,
  iconProps = {},
}) => {
  const icon = IconComponent ? <IconComponent {...iconProps} /> : null;

  const button = (
    <IconButton
      variant="outlined"
      size="large"
      onClick={onClick}
      {...iconProps}
      sx={{
        backgroundColor: "primary.brandMain",
        color: "primary.main",
        boxShadow: `4px 4px 12px ${theme.palette.secondary.lightBlack}70`,
        "&:hover": {
          backgroundColor: "primary.main",
          color: "primary.brandMain",
          boxShadow: `4px 4px 12px ${theme.palette.primary.main}70`,
          opacity: 0.9,
        },
      }}
    >
      {icon}
    </IconButton>
  );

  return tooltip ? <Tooltip title={tooltip}>{button}</Tooltip> : button;
};
